import { io } from "socket.io-client";

const rawBase = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_CHAT_API_URL || process.env.REACT_APP_API_URL || "http://localhost:5000";
const normalizedBase = String(rawBase || "").replace(/\/$/, "");

export function createSocket() {
  return io(normalizedBase, {
    path: "/socket.io",
    transports: ["polling", "websocket"],
    withCredentials: true,
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1500,
    timeout: 10000,
  });
}

export default normalizedBase;
